import { configureStore } from '@reduxjs/toolkit'

import eventsReducer from '../components/features/events/eventsSlice'
import { apiSlice } from '../components/features/api/apiSlice'


export default configureStore({
    reducer: {
        events: eventsReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(apiSlice.middleware)
})